import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";

interface IShowToastMessageActionPayload {
    messageText: string;
    messageType?: 'success' | 'info' | 'warn' | 'error';
    windowType?: string;
}

interface IToastMessageSlice {
    toastMessageIsShown: boolean;
    toastMessageText: string;
    toastMessageType?: 'success' | 'info' | 'warn' | 'error';
    toastMessageWindowType?: 'map' | 'panorama' | 'card';
    toastMessageContainerClearButtonIsClicked: boolean;
}

function getInitialState() {
    const initialState: IToastMessageSlice = {
        toastMessageIsShown: false,
        toastMessageText: "",
        toastMessageType: undefined,
        toastMessageWindowType: undefined,
        toastMessageContainerClearButtonIsClicked: false
    };
    return initialState
}

export const toastMessageSlice = createSlice({
    name: "toastMessage",
    initialState: getInitialState(),
    reducers: {
        showToastMessage(state, action: PayloadAction<IShowToastMessageActionPayload>) {
            const { messageText, messageType, windowType } = action.payload;
            state.toastMessageIsShown = true
            state.toastMessageText = messageText
            state.toastMessageType = messageType
            state.toastMessageWindowType = windowType
        },
        resetToastMessageSettings(state) {
            state.toastMessageIsShown = false
            state.toastMessageText = ""
            state.toastMessageType = undefined
            state.toastMessageWindowType = undefined
        },
        setToastMessageContainerClearButtonIsClicked(state, action: PayloadAction<any>) {
            state.toastMessageContainerClearButtonIsClicked = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState();
        });
    },
});

export const { showToastMessage, resetToastMessageSettings, setToastMessageContainerClearButtonIsClicked } = toastMessageSlice.actions;
export const toastMessageReducer = toastMessageSlice.reducer
